<script>
import { Inertia } from '@inertiajs/inertia'
import Edit from './edit.vue'

export default {
  extends: Edit,

  data() {
    return {
      ...Edit.data.call(this),
      title: 'Builds :: Add Build',
    }
  },

  methods: {
    submit() {
      Inertia.post(this.$route('builds.store'), this.getSubmitData(), {
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        },
        onSuccess: () => {
          this.formSuccess = true
        },
      })
    },

    getSubmitData() {
      return {
        ...Edit.methods.getSubmitData.call(this),
        vehicle_id: this.vehicle.id,
        part_id: this.part.id,
      }
    },
  },
}
</script>
